export const titleTextProps = () => ({
  as: 'h4',
  align: 'center',
  textTransform: 'uppercase',
});

export const subTitleTextProps = {
  as: 'h5',
  align: 'center',
  textTransform: 'none',
};

export const smallTextProps = {
  as: 'p',
  align: 'center',
  textTransform: 'uppercase',
};
